import { render, staticRenderFns } from "./Step5RestaurantsSelection.vue?vue&type=template&id=38309a56&scoped=true"
import script from "./Step5RestaurantsSelection.vue?vue&type=script&lang=js"
export * from "./Step5RestaurantsSelection.vue?vue&type=script&lang=js"
import style0 from "./Step5RestaurantsSelection.vue?vue&type=style&index=0&id=38309a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38309a56",
  null
  
)

export default component.exports